import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = import.meta.env.VITE_API_URL;

const AlphaRegister = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");  // Add name state
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [authorized, setAuthorized] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/auth/check-auth`, { credentials: 'include' });
        const data = await res.json();
		const demoUserId = localStorage.getItem("demoUserId");
		console.log(demoUserId);
        
        if (!data.loggedIn || parseInt(demoUserId, 10) !== 4) {
          navigate('/'); // redirect unauthorized users to home
        } else {
          setAuthorized(true); // authorized user
        }
      } catch (error) {
        navigate('/'); // redirect on error
      }
    };

    verifyUser();
  }, [navigate]);

	const handleRegister = async () => {
	  setMessage("");
	  setPassword("");

	  try {
		const res = await fetch(`${API_BASE_URL}/auth/alpha-register`, {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  credentials: "include",
		  body: JSON.stringify({ email, name }),  // Send name
		});

		const data = await res.json();
		if (!res.ok) throw new Error(data.message || "Registration failed.");

		setPassword(data.password);
		setMessage("✅ Demo user successfully created!");
	  } catch (error) {
		setMessage("❌ Error: " + error.message);
	  }
	};

  if (!authorized) {
    return null; // or a loading spinner
  }

  return (
    <div style={{
      padding: "40px",
      maxWidth: "500px",
      margin: "50px auto",
      background: "#f5f5f5",
      borderRadius: "8px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      color: "#333",
      fontFamily: "Arial, sans-serif"
    }}>
      <h2 style={{marginBottom: "20px"}}>Create Alpha User</h2>
      <input
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "15px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          boxSizing: "border-box"
        }}
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
	  <input
	  style={{
          width: "100%",
          padding: "10px",
          marginBottom: "15px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          boxSizing: "border-box"
        }}
		  type="text"
		  placeholder="Enter name"
		  value={name}
		  onChange={(e) => setName(e.target.value)}
		/>
      <button 
        style={{
          padding: "10px 20px",
          borderRadius: "4px",
          border: "none",
          background: "#4A90E2",
          color: "#fff",
          cursor: "pointer",
          marginBottom: "20px"
        }}
        onClick={handleRegister}
      >
        Generate Demo User
      </button>

      {message && (
        <p style={{ fontSize: "16px", fontWeight: "bold" }}>{message}</p>
      )}

      {password && (
        <p style={{ fontSize: "16px" }}>
          Generated password: <span style={{fontWeight: "bold", color: "#4A90E2"}}>{password}</span>
        </p>
      )}
    </div>
  );
};

export default AlphaRegister;
